import BaseAddressesController from "../base_addresses_controller";

// Connects to data-controller="detailing--addresses"
export default class extends BaseAddressesController {
  static targets = ["map", "branch"];

  placemarkCallback(selectedBranch) {
    this.#setPlacemarkActive(selectedBranch);
  }

  buildPlacemarkHTML(branch) {
    const parser = new DOMParser();
    const placemarkElement = parser.parseFromString(
      `
      <div class="-translate-x-7 -translate-y-14 cursor-pointer">
        <div class="size-14">
          <img src="${this.PLACEMARK_URL}">
        </div>
      </div>
    `,
      "text/html",
    ).body.childNodes[0];
    return placemarkElement;
  }

  showPlacemarkOnMap(event) {
    this.dispatch("placemark", { detail: { branchId: event.params.branchId } });
    this.ymap.setLocation({
      center: event.params.coordinates,
      zoom: 15,
    });
  }

  #setPlacemarkActive(selectedBranch) {
    const currentBranch = this.branchTargets.find((branchTarget) => {
      const coordinates = branchTarget.getAttribute(
        "data-detailing--addresses-coordinates-param",
      );
      return coordinates.includes(selectedBranch.data.xy.join(", "));
    });
    // Need for calling branchTarget callbacks
    const clickEvent = new MouseEvent("click");
    currentBranch.dispatchEvent(clickEvent);
  }
}
